<template>
  <div class="section8">
    <nav-menu style="color: #fff" @click="$emit('open')"></nav-menu>
    <div class="section8-container">
      <div class="section8-header">
        <h3 class="title">INDIBA 中国区</h3>
        <div class="tel">+86 010 8595 1863</div>
      </div>

      <div class="section8-body">
        <div class="address">
          <swiper :options="swiperOption">
            <swiper-slide>
              <div style="width: 70%">
                <div class="address-item">
                  <h3 class="address-item-title">BEIJING</h3>
                  <h3 class="address-item-title">英特波科技(北京)有限公司</h3>
                  <!-- <p class="address-item-desc">
                    北京市朝阳区建国路93号院1号楼1808室
                  </p> -->
                  <p class="address-item-desc">
                    北京市朝阳区光华路4号东方梅地亚中心C座2801
                  </p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div style="width: 70%">
                <div class="address-item">
                  <h3 class="address-item-title">SHENZHEN</h3>
                  <h3 class="address-item-title">英特波科技（深圳）有限公司</h3>
                  <p class="address-item-desc">
                    深圳市南山区粤海街道大冲社区<br />深南大道9668号华润置地大厦C座2708
                  </p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div style="width: 70%">
                <div class="address-item">
                  <h3 class="address-item-title">SHANGHAI</h3>
                  <h3 class="address-item-title">上海办公室</h3>
                  <p class="address-item-desc">
                    上海市长宁区古北路666号嘉麒大厦22楼01室
                  </p>
                  <p class="address-item-desc">
                    上海市长宁区凯旋路1398号3号楼1005室
                  </p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div style="width: 70%">
                <div class="address-item">
                  <h3 class="address-item-title">CHENGDU</h3>
                  <h3 class="address-item-title">成都办公室</h3>
                  <p class="address-item-desc">
                    成都市锦江区红星路三段1号<br />国际金融中心IFS3号办公楼41楼03号
                  </p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <ul class="media-channels">
          <li class="channel-item">
            <div class="item-left">
              <div class="channel-item-title">微信公众号：INDIBA</div>
              <div class="channel-item-desc">
                了解更多官方资讯 关注INDIBA官方微信公众号
              </div>
            </div>
            <i class="item-right">
              <img src="../../assets/img/indiba-wechat.jpeg" alt="">
            </i>
          </li>
          <li class="channel-item">
            <div class="item-left">
              <div class="channel-item-title">小红书：INDIBA</div>
              <div class="channel-item-desc">
                更多实效案例 关注INDIBA官方小红书官方账号
              </div>
            </div>
            <i class="item-right ri-qr-code-line"></i>
          </li>
          <li class="channel-item change-prod">
            <a href="http://www.indibachn.com:5002/wechat">索要产品与技术手册</a
            ><i class="ri-arrow-right-line"></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import NavMenu from "./components/NavMenu.vue";
import "vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
    NavMenu,
  },
  data() {
    return {
      swiperOption: {
        // slidesPerView: 'auto',
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.section8 {
  height: 100%;
  background: url(../../assets/home/mobile/section5/bg.png);
  background-size: 100%;
  background-repeat: no-repeat;
  position: relative;
  padding-right: 0;

  .section8-header {
    color: #fff;
    margin-left: 1.5rem;
    margin-bottom: 5rem;
    font-size: 1.3rem;
    h3 {
      color: #fff;
      margin: 0;
    }
  }

  .section8-container {
    position: absolute;
    width: 100%;
    bottom: 0;
  }

  .section8-body {
    height: 25rem;
    padding-left: 1.5rem;
    background: #365abd;
    position: relative;
  }

  .address {
    position: absolute;
    top: -2rem;
  }
  .address-item {
    background: #fff;
    border-radius: 3px;
    padding: 1rem;
    margin-right: 1rem;
    .address-item-title {
      font-size: 1rem;
      font-weight: 600;
      height: 1.125rem;
      line-height: 1.125rem;
      color: #000;
    }
    .address-item-desc {
      //   margin-top: 1.625rem;
      font-size: 0.875rem;
      color: rgba(0, 0, 0, 0.65);
      line-height: 1rem;
    }
  }

  .media-channels {
    padding-top: 9.5rem;
  }
  .channel-item {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    margin-right: 1.3rem;
    padding: 0.625rem;
    display: flex;
    align-items: center;
    &:last-child {
      padding: 0 0.625rem;
      height: 4rem;
      line-height: 4rem;
      font-size: 0.875rem;
      font-weight: 400;
      color: #ffffff;
      opacity: 1;
      border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    }
    .channel-item-title {
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 17px;
      color: #ffffff;
      opacity: 1;
    }
    .channel-item-desc {
      font-size: 0.625rem;
      font-weight: 400;
      line-height: 1.5rem;
      color: #ffffff;
      opacity: 0.65;
    }
    .item-left {
      flex: 1;
    }
    .item-right {
      width: 3rem;
      font-size: 1rem;
      text-align: right;
      color: #fff;
    }
  }
  .change-prod {
    a {
      color: #fff;
      flex: 1;
    }
    display: flex;
    align-items: center;
    i {
      width: 2rem;
      text-align: right;
    }
  }
}
</style>
